import Vue from "vue"
import Buefy from "buefy"
import SearchResultsList from "./App.vue"

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(SearchResultsList)

if(document.getElementById("searchResultsListApp")){
    new Vue({
        render: h=>h(
            SearchResultsList,{
                props:{
                    resultsEndpoint: document.getElementById("searchResultsListApp")
                        .getAttribute("results-endpoint"),
                    searchedTerm: document.getElementById("searchResultsListApp")
                        .getAttribute("searched-term"),
                    prodOnlyEndpoint: document.getElementById("searchResultsListApp")
                        .getAttribute("prod-only-endpoint")
                }
            }
        )
    }).$mount("#searchResultsListApp")
}